export default {
  path: '/wecode/market',
  auth: false,
  preload: false,
  key: 'market',
  isStatic: true,
  component: () => import('./index')
};
